export class Constants {
  public static svgParentSelector = 'body';

  public static arcs = {
    small: {
      angle: 120,
      r: 200
    },
    middle: {
      angle: 90,
      r: 240
    },
    large: {
      angle: 150,
      r: 280
    }
  };

  public static arcDiffStep = {
    angle: 5,
    r: 25
  };

  public static labelLimitDistance = 12;

  public static minimalTriangleBasedMultiplier = 6;

  public static maxDecreaseMultiplier = 0.5;

  public static componentsNumberToArcs = {
    large: 11,
    small: 11,
    middle: 7
  };

  /** this defines what shows up in the chart and in each section */
  public static categoryKeysToArcs: any = {
    large: ['THIA', 'RAE', 'RIBO', 'N-NE', 'B6', 'DFE', 'B12', 'VITC', 'D3+D2-µG', 'ATMG', 'VITK', 'PANT'],
    small: ['CA', 'CU', 'FE', 'MG', 'MN', 'P', 'K', 'SE', 'ZN', 'NA', 'CHL'],
    middle: ['CHOL', 'CARB', 'TDF', 'PROT', 'FAT', 'TSUG', 'SaturatedFat', 'HealthyFat' ] // '20:5n-3EPA', '22:6n-3DHA']
  };

  public static arcLabels = {
    large: 'Vitamins',
    small: 'Minerals',
    middle: 'Macronutrients'
  };

  public static categoryRectangleBase = 5;

  /** this definies what shows up in the nutrient table below the chart */
  public static publicNamesOfCategories: any = {
    'CHOL': 'Cholesterol',
    'SaturatedFat': 'Saturated Fat',
    'CARB': 'Carbohydrate',
    'TDF': 'Fibre',
    'PROT': 'Protein',
    'RAE': 'Vitamin A',
    'RIBO': 'Vitamin B2',
    'N-NE': 'Vitamin B3',
    'THIA': 'Vitamin B1',
    'B6': 'Vitamin B6',
    'DFE': 'Folacin',
    'B12': 'Vitamin B12',
    'VITC': 'Vitamin C',
    'D3+D2-µG': 'Vitamin D',
    'ATMG': 'Vitamin E',
    'VITK': 'Vitamin K',
    'PANT': 'Pantothenic Acid',
    'CA': 'Calcium',
    'CU': 'Copper',
    'FE': 'Iron',
    'MG': 'Magnesium',
    'MN': 'Manganese',
    'P': 'Phosphorus',
    'K': 'Potassium',
    'SE': 'Selenium',
    'ZN': 'Zinc',
    'NA': 'Sodium',
    'CHL': 'Chloride',
    'FAT': 'Total Fat',
    'TSUG': 'Total Sugar',
    'HealthyFat': 'Healthy Fat',
    '20:5n-3EPA': 'EPA',
    '22:6n-3DHA': 'DHA',
  };

  public static exportMenuId = 'export';
  public static importMenuId = 'import';

  public static svgId = 'FoodDiagramContainer';

  public static chartExportParams = {
    background: '#ffffff',
    scale: 2
  };

  public static maxFiles = 5;

  public static fileEvents = {
    add: 'Add-file',
    remove: 'Remove-file'
  };

  public static publicEvents = {
    reinitChart: 'Reinit-chart'
  };

  public static chartDescSpace = 325;
  public static exportXSpacing = 25;

  public static contactData: any = {
    site: 'www.fedfedfed.com',
    email: 'info@fedfedfed.com',
    phone: '6046553677'
  };

  public static legendSquareSize = 10;
  public static legendPadding = 7;

  public static legalDescriptionText = ['This diagram represents the percentage of nutrients present in each meal. Fed aims to provide you with 100% or more of Health Canada’s set Recommended Dietary Allowance (RDA) for each nutrient. Potassium, Vitamin K and Pantothenic Acid do not have RDAs. Targets are instead based on what is an Adequate Intake amount, that Fed does not attempt to meet.', 'Macronutrient targets are based on a 2000 calorie diet for a healthy individual, eating a mixed North American diet. Percent of calories are distributed as follows: 45% carbohydrate, 25% protein, 35% total fat, with <less than 10% of calories from saturated fat. Fibre is calculated as 14g per 1000 calories. Macronutrient needs vary by individual.'];
  public static legalDescriptionPadding = 5;
  public static logoText = ['fed', 'fed', 'fed'];
  public static logoPaddingNormalizationValue = 17;

  public static descriptionScaleFactor = 1.3;

  /** this is what shows up in the table below the chart */
  public static nutrientNameAndUnit: any = {
    'macro': {
      PROT: {
        name: 'PROTEIN',
        unit: 'g'
      },
      FAT: {
        name: 'FAT (TOTAL LIPIDS)',
        unit: 'g'
      },
      CARB: {
        name: 'CARBOHYDRATE, TOTAL (BY DIFFERENCE)',
        unit: 'g'
      },
      NETCARB: {
        name: 'CARBOHYDRATES, MINUS FIBERS',
        unit: 'g'
      },
      KCAL: {
        name: 'ENERGY (KILOCALORIES)',
        unit: 'kCal'
      },
      HealthyFat: {
        name: 'HEALTHY FAT',
        unit: 'g'
      },
      '22:6n-3DHA': {
        name: 'DHA',
        unit: 'g'
      },
      '20:5n-3EPA' : {
        name: 'EPA',
        unit: 'g'
      },
      MUFA: {
        name: 'FATTY ACIDS, MONOUNSATURATED, TOTAL',
        unit: 'g'
      },
      PUFA: {
        name: 'FATTY ACIDS, POLYUNSATURATED, TOTAL',
        unit: 'g'
      },
      SaturatedFat: {
        name: 'SATURATED FAT',
        unit: 'g'
      },
      TRFA: {
        name: 'FATTY ACIDS, TRANS, TOTAL',
        unit: 'g'
      },
      TSAT: {
        name: 'FATTY ACIDS, SATURATED, TOTAL',
        unit: 'g'
      },
      TDF: {
        name: 'FIBRE, TOTAL DIETARY',
        unit: 'g'
      },
      SUCR: {
        name: 'SUCROSE',
        unit: 'g'
      },
      TSUG: {
        name: 'SUGARS, TOTAL',
        unit: 'g'
      },
      CHOL: {
        name: 'CHOLESTEROL',
        unit: 'mg'
      },
    },
    'vitamins': {
      'RAE': {
        name: 'VITAMIN A',
        unit: 'µg'
      },
      'THIA': {
        name: 'VITAMIN B1',
        unit: 'mg'
      },
      'RIBO': {
        name: 'VITAMIN B2',
        unit: 'mg'
      },
      'N-NE': {
        name: 'VITAMIN B3',
        unit: 'NE'
      },
      'B6': {
        name: 'VITAMIN B6',
        unit: 'mg'
      },
      'B12': {
        name: 'VITAMIN B-12',
        unit: 'µg'
      },
      'VITC': {
        name: 'VITAMIN C',
        unit: 'mg'
      },
      'D3+D2-µG': {
        name: 'VITAMIN D (D2 + D3)',
        unit: 'µg'
      },
      'ATMG': {
        name: 'VITAMIN E',
        unit: 'mg'
      },
      'VITK': {
        name: 'VITAMIN K',
        unit: 'µg'
      },
      'FOLA': {
        name: 'TOTAL FOLACIN',
        unit: 'µg'
      },
      'PANT': {
        name: 'PANTOTHENIC ACID',
        unit: 'mg'
      }
    },
    'minerals': {
      CA: {
        name: 'CALCIUM',
        unit: 'mg'
      },
      CU: {
        name: 'COPPER',
        unit: 'mg'
      },
      FE: {
        name: 'IRON',
        unit: 'mg'
      },
      MG: {
        name: 'MAGNESIUM',
        unit: 'mg'
      },
      MN: {
        name: 'MANGANESE',
        unit: 'mg'
      },
      P: {
        name: 'PHOSPHORUS',
        unit: 'mg'
      },
      K: {
        name: 'POTASSIUM',
        unit: 'mg'
      },
      SE: {
        name: 'SELENIUM',
        unit: 'µg'
      },
      ZN: {
        name: 'ZINC',
        unit: 'mg'
      },
      NA: {
        name: 'SODIUM',
        unit: 'mg'
      },
      CHL: {
        name: 'CHLORIDE',
        unit: 'mg'
      }
    },
    'ASH': {
      name: 'ASH, TOTAL',
      unit: 'g'
    },
    'STAR': {
      name: 'STARCH',
      unit: 'g'
    },
    'GLUC': {
      name: 'GLUCOSE',
      unit: 'g'
    },
    'FRUC': {
      name: 'FRUCTOSE',
      unit: 'g'
    },
    'LACT': {
      name: 'LACTOSE',
      unit: 'g'
    },
    'MALT': {
      name: 'MALTOSE',
      unit: 'g'
    },
    'ALCO': {
      name: 'ALCOHOL',
      unit: 'g'
    },
    'OXAL': {
      name: 'OXALIC ACID',
      unit: 'mg'
    },
    'H2O': {
      name: 'MOISTURE',
      unit: 'g'
    },
    'MANN': {
      name: 'MANNITOL',
      unit: 'g'
    },
    'SORB': {
      name: 'SORBITOL',
      unit: 'g'
    },
    'CAFF': {
      name: 'CAFFEINE',
      unit: 'mg'
    },
    'THBR': {
      name: 'THEOBROMINE',
      unit: 'mg'
    },
    'KJ': {
      name: 'ENERGY (KILOJOULES)',
      unit: 'kJ'
    },
    'GAL': {
      name: 'GALACTOSE',
      unit: 'g'
    },
    'RT-µG': {
      name: 'RETINOL',
      unit: 'µg'
    },
    'BC-µG': {
      name: 'BETA CAROTENE',
      unit: 'µg'
    },
    'AC-µG': {
      name: 'ALPHA CAROTENE',
      unit: 'µg'
    },
    'D-IU': {
      name: 'VITAMIN D (INTERNATIONAL UNITS)',
      unit: 'IU'
    },
    'D2-µG': {
      name: 'VITAMIN D2, ERGOCALCIFEROL',
      unit: 'µg'
    },
    'CRYPX': {
      name: 'BETA CRYPTOXANTHIN',
      unit: 'µg'
    },
    'LYCPN': {
      name: 'LYCOPENE',
      unit: 'µg'
    },
    'LUT+ZEA': {
      name: 'LUTEIN AND ZEAXANTHIN',
      unit: 'µg'
    },
    'BTMG': {
      name: 'BETA-TOCOPHEROL',
      unit: 'mg'
    },
    'GTMG': {
      name: 'GAMMA-TOCOPHEROL',
      unit: 'mg'
    },
    'DTMG': {
      name: 'DELTA-TOCOPHEROL',
      unit: 'mg'
    },
    'N-MG': {
      name: 'NIACIN (NICOTINIC ACID) PREFORMED',
      unit: 'mg'
    },
    'BIOT': {
      name: 'BIOTIN',
      unit: 'µg'
    },
    'CHOLN': {
      name: 'CHOLINE, TOTAL',
      unit: 'mg'
    },
    'FOAC': {
      name: 'FOLIC ACID',
      unit: 'µg'
    },
    'FOLN': {
      name: 'NATURALLY OCCURRING FOLATE',
      unit: 'µg'
    },
    'DFE': {
      name: 'DIETARY FOLATE EQUIVALENTS',
      unit: 'µg'
    },
    'BETN': {
      name: 'BETAINE',
      unit: 'mg'
    },
    'TRP': {
      name: 'TRYPTOPHAN',
      unit: 'g'
    },
    'THR': {
      name: 'THREONINE',
      unit: 'g'
    },
    'ISO': {
      name: 'ISOLEUCINE',
      unit: 'g'
    },
    'LEU': {
      name: 'LEUCINE',
      unit: 'g'
    },
    'LYS': {
      name: 'LYSINE',
      unit: 'g'
    },
    'MET': {
      name: 'METHIONINE',
      unit: 'g'
    },
    'CYS': {
      name: 'CYSTINE',
      unit: 'g'
    },
    'PHE': {
      name: 'PHENYLALANINE',
      unit: 'g'
    },
    'TYR': {
      name: 'TYROSINE',
      unit: 'g'
    },
    'VAL': {
      name: 'VALINE',
      unit: 'g'
    },
    'ARG': {
      name: 'ARGININE',
      unit: 'g'
    },
    'HIS': {
      name: 'HISTIDINE',
      unit: 'g'
    },
    'ALA': {
      name: 'ALANINE',
      unit: 'g'
    },
    'ASP': {
      name: 'ASPARTIC ACID',
      unit: 'g'
    },
    'GLU': {
      name: 'GLUTAMIC ACID',
      unit: 'g'
    },
    'GLY': {
      name: 'GLYCINE',
      unit: 'g'
    },
    'PRO': {
      name: 'PROLINE',
      unit: 'g'
    },
    'SER': {
      name: 'SERINE',
      unit: 'g'
    },
    'HYP': {
      name: 'HYDROXYPROLINE',
      unit: 'g'
    },
    'ASPA': {
      name: 'ASPARTAME',
      unit: 'mg'
    },
    'ATMG-A': {
      name: 'ALPHA-TOCOPHEROL, ADDED',
      unit: 'mg'
    },
    'B12-A': {
      name: 'VITAMIN B12, ADDED',
      unit: 'µg'
    },
    '4:0': {
      name: 'FATTY ACIDS, SATURATED, 4:0, BUTANOIC',
      unit: 'g'
    },
    '6:0': {
      name: 'FATTY ACIDS, SATURATED, 6:0, HEXANOIC',
      unit: 'g'
    },
    '8:0': {
      name: 'FATTY ACIDS, SATURATED, 8:0, OCTANOIC',
      unit: 'g'
    },
    '10:0': {
      name: 'FATTY ACIDS, SATURATED, 10:0, DECANOIC',
      unit: 'g'
    },
    '12:0': {
      name: 'FATTY ACIDS, SATURATED, 12:0, DODECANOIC',
      unit: 'g'
    },
    '14:0': {
      name: 'FATTY ACIDS, SATURATED, 14:0, TETRADECANOIC',
      unit: 'g'
    },
    '16:0': {
      name: 'FATTY ACIDS, SATURATED, 16:0, HEXADECANOIC',
      unit: 'g'
    },
    '18:0': {
      name: 'FATTY ACIDS, SATURATED, 18:0, OCTADECANOIC',
      unit: 'g'
    },
    '20:0': {
      name: 'FATTY ACIDS, SATURATED, 20:0, EICOSANOIC',
      unit: 'g'
    },
    '18:1undiff': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 18:1undifferentiated, OCTADECENOIC',
      unit: 'g'
    },
    '18:2undiff': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:2undifferentiated, LINOLEIC, OCTADECADIENOIC',
      unit: 'g'
    },
    '18:3undiff': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:3undifferentiated, LINOLENIC, OCTADECATRIENOIC',
      unit: 'g'
    },
    '20:4undiff': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:4, EICOSATETRAENOIC',
      unit: 'g'
    },
    '22:6n-3DHA': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 22:6 n-3, DOCOSAHEXAENOIC (DHA)',
      unit: 'g'
    },
    '22:0': {
      name: 'FATTY ACIDS, SATURATED, 22:0, DOCOSANOIC',
      unit: 'g'
    },
    '14:1': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 14:1, TETRADECENOIC',
      unit: 'g'
    },
    '16:1undiff': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 16:1undifferentiated, HEXADECENOIC',
      unit: 'g'
    },
    '18:4': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:4, OCTADECATETRAENOIC',
      unit: 'g'
    },
    '20:1': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 20:1, EICOSENOIC',
      unit: 'g'
    },
    '20:5n-3EPA': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:5 n-3, EICOSAPENTAENOIC (EPA)',
      unit: 'g'
    },
    '22:1undiff': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 22:1undifferentiated, DOCOSENOIC',
      unit: 'g'
    },
    '22:5n-3DPA': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 22:5 n-3, DOCOSAPENTAENOIC (DPA)',
      unit: 'g'
    },
    'TPST': {
      name: 'TOTAL PLANT STEROL',
      unit: 'mg'
    },
    'STIG': {
      name: 'STIGMASTEROL',
      unit: 'mg'
    },
    'CAMSTR': {
      name: 'CAMPESTEROL',
      unit: 'mg'
    },
    'SITSTR': {
      name: 'BETA-SITOSTEROL',
      unit: 'mg'
    },
    '15:0': {
      name: 'FATTY ACIDS, SATURATED, 15:0, PENTADECANOIC',
      unit: 'g'
    },
    '17:0': {
      name: 'FATTY ACIDS, SATURATED, 17:0, HEPTADECANOIC',
      unit: 'g'
    },
    '24:0': {
      name: 'FATTY ACIDS, SATURATED, 24:0, TETRACOSANOIC',
      unit: 'g'
    },
    '16:1t': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 16:1t, HEXADECENOIC',
      unit: 'g'
    },
    '18:1t': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 18:1t, OCTADECENOIC',
      unit: 'g'
    },
    '22:1t': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 22:1t, DOCOSENOIC',
      unit: 'g'
    },
    '18:2i': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:2i, LINOLEIC, OCTADECADIENOIC',
      unit: 'g'
    },
    '18:2t,t': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:2t,t , OCTADECADIENENOIC',
      unit: 'g'
    },
    '18:2cla': {
      name: 'FATTY ACIDS, POLYUNSATURATED, CONJUGATED, 18:2 cla, LINOLEIC, OCTADECADIENOIC',
      unit: 'g'
    },
    '24:1c': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 24:1c, TETRACOSENOIC',
      unit: 'g'
    },
    '20:2cc': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:2 c,c  EICOSADIENOIC',
      unit: 'g'
    },
    '16:1c': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 16:1c, HEXADECENOIC',
      unit: 'g'
    },
    '18:1c': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 18:1c, OCTADECENOIC',
      unit: 'g'
    },
    '18:2ccn-6': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:2 c,c n-6,  LINOLEIC, OCTADECADIENOIC',
      unit: 'g'
    },
    '22:1c': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 22:1c, DOCOSENOIC',
      unit: 'g'
    },
    '18:3cccn-6': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:3 c,c,c n-6, g-LINOLENIC, OCTADECATRIENOIC',
      unit: 'g'
    },
    '17:1': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 17:1, HEPTADECENOIC',
      unit: 'g'
    },
    '20:3undiff': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:3, EICOSATRIENOIC',
      unit: 'g'
    },
    'TRMO': {
      name: 'FATTY ACIDS, TOTAL TRANS-MONOENOIC',
      unit: 'g'
    },
    'TRPO': {
      name: 'FATTY ACIDS, TOTAL TRANS-POLYENOIC',
      unit: 'g'
    },
    '13:0': {
      name: 'FATTY ACIDS, SATURATED, 13:0 TRIDECANOIC',
      unit: 'g'
    },
    '15:1': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 15:1, PENTADECENOIC',
      unit: 'g'
    },
    'TMOS': {
      name: 'TOTAL MONOSACCARIDES',
      unit: 'g'
    },
    'TDIS': {
      name: 'TOTAL DISACCHARIDES',
      unit: 'g'
    },
    '18:3cccn-3': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:3 c,c,c n-3  LINOLENIC, OCTADECATRIENOIC',
      unit: 'g'
    },
    '20:3n-3': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:3 n-3 EICOSATRIENOIC',
      unit: 'g'
    },
    '20:3n-6': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:3 n-6, EICOSATRIENOIC',
      unit: 'g'
    },
    '20:4n-6': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 20:4 n-6, ARACHIDONIC',
      unit: 'g'
    },
    '18:3i': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 18:3i, LINOLENIC, OCTADECATRIENOIC',
      unit: 'g'
    },
    '21:5': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 21:5',
      unit: 'g'
    },
    '22:4n-6': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 22:4 n-6, DOCOSATETRAENOIC',
      unit: 'g'
    },
    '24:1undiff': {
      name: 'FATTY ACIDS, MONOUNSATURATED,  24:1undifferentiated, TETRACOSENOIC',
      unit: 'g'
    },
    '12:1': {
      name: 'FATTY ACIDS, MONOUNSATURATED, 12:1, LAUROLEIC',
      unit: 'g'
    },
    '22:3': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 22:3,',
      unit: 'g'
    },
    '22:2': {
      name: 'FATTY ACIDS, POLYUNSATURATED, 22:2, DOCOSADIENOIC',
      unit: 'g'
    },
    'TOmega n-3': {
      name: 'FATTY ACIDS, POLYUNSATURATED, TOTAL OMEGA  N-3',
      unit: 'g'
    },
    'TOmega n-6': {
      name: 'FATTY ACIDS, POLYUNSATURATED, TOTAL OMEGA   N-6',
      unit: 'g'
    }
  };
}
